var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "league-assistant" },
    [
      _c(
        "a-row",
        { attrs: { type: "flex" } },
        [
          _c("a-col", { attrs: { flex: "230px" } }, [
            _c(
              "div",
              { staticClass: "flex-between" },
              [
                _c("span", { staticClass: "title-2" }, [_vm._v("团辅方案")]),
                _c(
                  "a-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.createLeague },
                  },
                  [_vm._v("创建")]
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c(
                  "a-directory-tree",
                  {
                    attrs: {
                      multiple: "",
                      "default-expand-all": "",
                      selectedKeys: _vm.selectedKeys,
                    },
                    on: { select: _vm.onSelect, expand: _vm.onExpand },
                  },
                  _vm._l(_vm.treeData, function (item) {
                    return _c(
                      "a-tree-node",
                      { key: item.key },
                      [
                        _c(
                          "template",
                          { slot: "title" },
                          [
                            _c(
                              "span",
                              { staticStyle: { "margin-right": "20px" } },
                              [_vm._v(_vm._s(item.title))]
                            ),
                            _c("a-icon", {
                              style: { fontSize: "16px", color: "#1783E8" },
                              attrs: { type: "edit" },
                              on: {
                                click: function ($event) {
                                  $event.stopPropagation()
                                  return _vm.editLeague(item)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      2
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ]),
          _c(
            "a-col",
            { attrs: { flex: "2px" } },
            [
              _c("a-divider", {
                staticStyle: { height: "400px" },
                attrs: { type: "vertical" },
              }),
            ],
            1
          ),
          _c("a-col", { attrs: { flex: "auto" } }, [
            _c("div", {
              staticStyle: { "margin-left": "10px" },
              domProps: { innerHTML: _vm._s(_vm.currContent) },
            }),
          ]),
        ],
        1
      ),
      _c("CreateLeagueModal", {
        ref: "createLeagueModalRef",
        on: { refreshData: _vm.getTeamAssistant },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }